// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';
import SystemBus from 'core/entities/SystemBus';
import AwsSystem from 'aws/AwsSystem';

/**
 * @autodoc apply FsmAction
 */
class AwsSdkReadyAction extends Action {
  static getTransitionLabel(transitionKey, actionConfig) {
    return 'On AWS SDK Ready';
  }

  enter(fsm) {
    this._eventListener = () => fsm.send(this.transitions.transition);
    SystemBus.addListener(AwsSystem.SDK_READY, this._eventListener, true);
  }

  exit(fsm) {
    SystemBus.removeListener(AwsSystem.SDK_READY, this._eventListener);
  }
}

AwsSdkReadyAction.external = {
  key: 'AwsSdkReady',
  type: 'AWS',
  name: 'AWS SDK Ready',
  description:
    'Performs a transition when the AWS SDK has been initialized and is ready for use.',
  canTransition: true,
  parameters: [],
  transitions: [
    {
      key: 'transition',
      description: 'State to which to transition.',
    },
  ],
};

AwsSdkReadyAction.register();

export default AwsSdkReadyAction;
